type FetchOptions = RequestInit & {
  skipAuth?: boolean;
};

export const fetchAPI = async (endpoint: string, options: FetchOptions = {}) => {
  try {
    const baseUrl = import.meta.env.DEV
      ? '/api/v1'
      : (import.meta.env.VITE_API_URL || 'https://api.hakancakmak.com/api/v1');
    const normalizedBase = baseUrl.replace(/\/$/, '');
    const normalizedEndpoint = endpoint.replace(/^\//, '');
    const url = `${normalizedBase}/${normalizedEndpoint}`;
    const firebaseTokenFromStorage = () => {
      const keys = Object.keys(localStorage);
      const firebaseKey = keys.find((key) => key.startsWith('firebase:authUser:'));
      if (!firebaseKey) return null;
      try {
        const raw = localStorage.getItem(firebaseKey);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as { stsTokenManager?: { accessToken?: string } };
        return parsed.stsTokenManager?.accessToken || null;
      } catch {
        return null;
      }
    };
    const { skipAuth, ...requestOptions } = options;
    const authToken = skipAuth
      ? null
      : localStorage.getItem('token') ||
        localStorage.getItem('authToken') ||
        localStorage.getItem('idToken') ||
        localStorage.getItem('firebaseIdToken') ||
        firebaseTokenFromStorage() ||
        sessionStorage.getItem('token') ||
        sessionStorage.getItem('authToken') ||
        sessionStorage.getItem('idToken') ||
        sessionStorage.getItem('firebaseIdToken');
    const mergedHeaders = new Headers({
      'Accept': 'application/json',
    });
    if (authToken && !mergedHeaders.has('Authorization')) {
      mergedHeaders.set('Authorization', `Bearer ${authToken}`);
    }
    if (options.headers) {
      const optionHeaders = new Headers(options.headers);
      optionHeaders.forEach((value, key) => mergedHeaders.set(key, value));
    }
    const response = await fetch(url, {
      method: 'GET',
      ...requestOptions,
      headers: mergedHeaders,
    });
    if (!response.ok) {
      throw new Error(`API hatası: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('API isteği başarısız:', error);
    throw error;
  }
}; 
